'use client'

import { ENV } from '@/lib/env'
import { onCLS, onFCP, onLCP, onTTFB, onINP } from 'web-vitals'

function sendToAnalytics(metric: any) {
  const body = {
    name: metric.name,
    value: metric.value,
    rating: metric.rating,
    delta: metric.delta,
    id: metric.id,
    navigationType: metric.navigationType,
  }

  // Log en dev
  console.log(`${new Date().toISOString()} [Next.js] [Web Vitals] ${metric.name}:`, metric.value, metric.rating)

  // Envoyer au backend analytics
  if (typeof window !== 'undefined') {

    fetch(ENV.ANALYTICS_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event: 'web_vital',
        properties: body,
      }),
      keepalive: true,
    }).catch((error) => {
      console.error(`${new Date().toISOString()} [Next.js] [Web Vitals] ERROR failed to send web vital:`, error)
    })
  }
}

export function reportWebVitals() {
  if (typeof window === 'undefined') return

  try {
    onCLS(sendToAnalytics)
    onFCP(sendToAnalytics)
    onLCP(sendToAnalytics)
    onTTFB(sendToAnalytics)
    onINP(sendToAnalytics)
  } catch (error) {
    if (ENV.IS_STAGING) {
      console.error(`${new Date().toISOString()} [Next.js] ERROR Error setting up web vitals:`, error)
    }
  }
}
